import {DATA_TYPES, VIEW_TYPES} from "./fieldTypes";

export const RETAIL_LOCATION_FIELDS = [
    {
        name: "businessUnitCode",
        key: "businessUnitCode",
        dataType: DATA_TYPES.STRING,
        viewType: VIEW_TYPES.SINGLE_SELECT,
        label: "Business Unit",
        modes: ["create", "update"],
        requiredForCreate: true,
        sortOrder: 1,
    },
    {
        name: "countryCode",
        key: "countryCode",
        dataType: DATA_TYPES.STRING,
        viewType: VIEW_TYPES.SINGLE_SELECT,
        label: "Country",
        modes: ["create", "update"],
        requiredForCreate: false,
        sortOrder: 8,
    },
    {
        name: "shiptoId",
        key: "shiptoId",
        dataType: DATA_TYPES.STRING,
        viewType: VIEW_TYPES.TEXT,
        label: "Ship-to",
        modes: ["create", "update"],
        requiredForCreate: true,
        sortOrder: 2,
    },
    {
        name: "displayName",
        key: "displayName",
        dataType: DATA_TYPES.STRING,
        viewType: VIEW_TYPES.TEXT,
        label: "Name",
        modes: ["create", "update"],
        requiredForCreate: true,
        sortOrder: 3,
    },
    {
        name: "street",
        key: "street",
        dataType: DATA_TYPES.STRING,
        viewType: VIEW_TYPES.TEXT,
        label: "Street",
        modes: ["create", "update"],
        requiredForCreate: true,
        sortOrder: 4,
    },
    {
        name: "city",
        key: "city",
        dataType: DATA_TYPES.STRING,
        viewType: VIEW_TYPES.TEXT,
        label: "City",
        modes: ["create", "update"],
        requiredForCreate: true,
        sortOrder: 5,
    },
    {
        name: "state",
        key: "state",
        dataType: DATA_TYPES.STRING,
        viewType: VIEW_TYPES.SINGLE_SELECT,
        label: "State",
        modes: ["create", "update"],
        requiredForCreate: true,
        maxLength: 2,
        sortOrder: 6,
    },
    {
        name: "postalCode",
        key: "postalCode",
        dataType: DATA_TYPES.STRING,
        viewType: VIEW_TYPES.TEXT,
        label: "Postal Code",
        modes: ["create", "update"],
        requiredForCreate: true,
        sortOrder: 7,
    },
    {
        name: "onWebsite",
        key: "onWebsite",
        dataType: DATA_TYPES.BOOLEAN,
        viewType: VIEW_TYPES.CHECKBOX,
        defaultValue: true,
        label: "On Website",
        modes: ["create", "update"],
        requiredForCreate: false,
        sortOrder: 9,
    },
    {
        name: "bookingLink",
        key: "bookingLink",
        dataType: DATA_TYPES.STRING,
        viewType: VIEW_TYPES.TEXT,
        label: "Booking Link",
        modes: ["create", "update"],
        requiredForCreate: false,
        sortOrder: 10,
    },
    {
        name: "selectFitEbsCode",
        key: "selectFitEbsCodeId",
        dataType: DATA_TYPES.OBJECT,
        viewType: VIEW_TYPES.SINGLE_SELECT,
        label: "Select Fit EBS Code",
        modes: ["create", "update"],
        requiredForCreate: true,
        sortOrder: 11,
    },
    {
        name: "selectFitCategory",
        key: "selectFitCategoryId",
        dataType: DATA_TYPES.OBJECT,
        viewType: VIEW_TYPES.SINGLE_SELECT,
        label: "Select Fit Category",
        modes: ["create", "update"],
        requiredForCreate: false,
        sortOrder: 12,
    },
    {
        name: "selectFitLogoType",
        key: "selectFitLogoTypeId",
        dataType: DATA_TYPES.OBJECT,
        viewType: VIEW_TYPES.SINGLE_SELECT,
        label: "Select Fit Logo Type",
        modes: ["create", "update"],
        requiredForCreate: true,
        sortOrder: 13,
    },
    {
        name: "active",
        key: "active",
        dataType: DATA_TYPES.BOOLEAN,
        viewType: VIEW_TYPES.CHECKBOX,
        defaultValue: true,
        label: "Active",
        modes: ["update"],
        requiredForCreate: false,
        sortOrder: 14,
    },
    {
        name: "isRetailer",
        key: "isRetailer",
        dataType: DATA_TYPES.BOOLEAN,
        viewType: VIEW_TYPES.CHECKBOX,
        defaultValue: true,
        label: "Is Retailer",
        modes: ["update"],
        requiredForCreate: false,
        sortOrder: 15,
    },
];
